<ng-template #menuItem let-item="item" let-i="i">
  @if (item.isFullLink) {
    <a class="menuItem" id="menuItem__" [href]="item.link">
      <span class="menuItem__label">{{ item.url }}</span>
    </a>
  }
  @else if (item.isInternal && !item.isCustomPage) {
    <a class="menuItem" id="menuItem__" [routerLink]="this.language + '/' + item.link" routerLinkActive="active"  (click)="scrollUp()" [class.activated]="Router.url === '/' && item.link === '/home'">
      <span class="menuItem__label">{{ item.url }}</span>
    </a>
  }
  @else if (item.isCustomPage) {
    <a class="menuItem" [routerLink]="this.language + '/pages/' + item.link" routerLinkActive="active" (click)="scrollUp()">
      <span class="menuItem__label">{{ item.url }}</span>
    </a>
  }
  @else {
    <a class="menuItem" [href]="item.link" target="_blank">
      <span class="menuItem__label">{{ item.url }}</span>
    </a>
  }
</ng-template>

<ng-template #dropdown let-type="type" let-list="list" let-selected="selected">
  <div class="dropdown__backdrop" (click)="closeDropdown(type)"></div>
  <div class="dropdown__content">
    <div class="dropdown__scroller">
      @for (item of list; track $index) {
        <div class="dropdown__item"
          [class.dropdown__item--active]="item === selected"
          (click)="type === 'currency' ? useCurrency(item) : useLanguage(item)"
        >
          @if (type ==='currency') {
            <app-flag [currency]="item"></app-flag>
          } @else {
            <app-flag [language]="item"></app-flag>
          }
          <span>{{
            ("GENERAL."+ (type ==='currency' ? 'CURRENCY' : 'LANGUAGE')+"." + item.toString().toUpperCase()) | translate
          }}</span>
        </div>
      }
    </div>
  </div>
</ng-template>

@if (secondaryMenu && secondaryMenu.length) {
  <div class="navbar__secondary" #subMenuInstance>
     <ul class="navbar__secondary__menu" #secondaryMenuInstance>  
        @for (item of secondaryMenu; track $index; let i = $index) {
          <li [class.hidden]="!item._visible">
            @if (i !== 0) {
              <span class="divider">|</span>
            }
            <ng-container *ngTemplateOutlet="menuItem; context: { item: item, i} "></ng-container>
          </li>
        }
        @if (secondaryMenuHiddenCount > 0) {
          <li class="navbar__more" #secondaryMoreBtn>
            <span (click)="secondaryMenuExtraVisible = !secondaryMenuExtraVisible" class="icon-menu"></span>
            @if (secondaryMenuExtraVisible) {
              <div class="dropdown">
                <div class="dropdown__backdrop" (click)="secondaryMenuExtraVisible = false"></div>
                <div class="dropdown__content">
                  <div class="dropdown__scroller">
                    @for (x of secondaryMenu; track $index) {
                      @if (!x._visible) {
                        <ng-container *ngTemplateOutlet="menuItem; context: { item: x} "></ng-container>
                      }
                    }
                  </div>
                </div>
              </div>
            }
          </li>
        }
      </ul>
      <div class="navbar__secondary__social">
        @for (item of clientObject.social | keyvalue; track $index) {
          @if (item.value) {
            <a [href]="item.value" target="_blank" [class]="'icon-'+item.key"></a>
          }
        }
      </div>
  </div>
}

@if (mainMenu) {
  <div class="navbar__main">
    @if (clientObject.clientHeaderLogo){
      @if (clientObject.homepageURL) {
        <a class="navbar__main__logo" [href]="clientObject.homepageURL">
          <img
            [src]="clientObject.clientHeaderLogo"
            [alt]="clientObject.clientName + ' logo'"
          />
        </a>
      }
      @else {
        <div class="navbar__main__logo">
          <img
            (click)="navigateHome($event)"
            [src]="clientObject.clientHeaderLogo"
            [alt]="clientObject.clientName + ' logo'"
          />
        </div>
      }
    }
    <ul class="navbar__main__menu desktop-view" #mainMenuInstance>
      @for (item of mainMenu; track $index) {
        <li [class.hidden]="!item._visible">
          <ng-container *ngTemplateOutlet="menuItem; context: { item: item} "></ng-container>
        </li>
      }
      @if (mainMenuHiddenCount > 0) {
        <li class="navbar__more"  #mainMoreBtn>
          <span (click)="mainMenuExtraVisible = !mainMenuExtraVisible" class="icon-menu"></span>
          @if (mainMenuExtraVisible) {
            <div class="dropdown">
              <div class="dropdown__backdrop" (click)="mainMenuExtraVisible = false"></div>
              <div class="dropdown__content">
                <div class="dropdown__scroller">
                  @for (x of mainMenu; track $index) {
                    @if (!x._visible) {
                      <ng-container *ngTemplateOutlet="menuItem; context: { item: x} "></ng-container>
                    }
                  }
                </div>
              </div>
            </div>
          }
        </li>
      }
    </ul>
    <div class="navbar__main__extra">
      @if (clientObject.isLoginEnabled) {
        @if (this.user) {
          <div class="dropdown">
            <a class="menuItem" (click)="userMenuVisible = !userMenuVisible">
              <i class="icon-user-circle"></i><span class="menuItem__user">{{ this.user.forename }} {{ this.user.surname }}</span>
            </a>
            @if (userMenuVisible) {
              <div class="dropdown__backdrop" (click)="closeDropdown('user')"></div>
              <div class="dropdown__content">
                <div class="dropdown__scroller">
                  <a *appIsEnabled="'showEditMyProfile'" class="menuItem menuItem--dropdown" (click)="editMyProfile()" routerLinkActive="active">
                    <span class="icon-logout"></span>
                    <span class="menuItem__label">{{ "USERS.EDIT_PROFILE" | translate }}</span>
                  </a>
                  <a class="menuItem menuItem--dropdown" (click)="closeDropdown('user'); signOut()" routerLinkActive="active">
                    <span class="icon-logout"></span>
                    <span class="menuItem__label">{{ "GENERAL.SIGN_OUT" | translate }}</span>
                  </a>
                  
                </div>
              </div>
            }
          </div>
          
        }
        @else {
          <a class="menuItem" [routerLink]="this.language + '/login'" routerLinkActive="active">
            <span class="icon-user-circle"></span>
            <span class="menuItem__label">{{ "GENERAL.SIGN_IN" | translate }}</span>
          </a>
        }
      }

      <div class="dropdown desktop-view">
        <a class="menuItem active uppercase" (click)="languageVisible = !languageVisible">
          <span class="menuItem__label">{{ selectedLanguage }}</span>
          <span class="icon-angle-down"></span>
        </a>
        @if (languageVisible) {
          <ng-container *ngTemplateOutlet="dropdown; context: {
            list: clientObject.listOfLanguages,
            selected: selectedLanguage,
            type: 'language',
          }"></ng-container>
        }
      </div>
      <div class="dropdown desktop-view">
        <a class="menuItem active uppercase" (click)="currencyVisible = !currencyVisible">
          <span class="menuItem__label">{{ selectedCurrency }}</span>
          <span class="icon-angle-down"></span>
        </a>
        @if (currencyVisible) {
          <ng-container *ngTemplateOutlet="dropdown; context: {
            list: clientObject.listOfCurrencies,
            selected: selectedCurrency,
            type: 'currency',
          }"></ng-container> 
        }
      </div>

      <div class="mobileMenu__trigger mobile-view" (click)="mobileMenuVisible = true">
        <span class="icon-menu"></span>
      </div>

      <div class="mobileMenu mobile-view" [class.active]="mobileMenuVisible">
        <div class="mobileMenu__holder">
          <div class="mobileMenu__tools">
            <div class="mobileMenu__options">
              <div class="dropdown">
                <a class="menuItem active uppercase" (click)="languageVisible = !languageVisible">
                  <span class="menuItem__label">{{ selectedLanguage }}</span>
                  <span class="icon-angle-down"></span>
                </a>
                @if (languageVisible) {
                  <ng-container *ngTemplateOutlet="dropdown; context: {
                    list: clientObject.listOfLanguages,
                    selected: selectedLanguage,
                    type: 'language',
                  }"></ng-container>
                }
              </div>
              <div class="dropdown">
                <a class="menuItem active uppercase" (click)="currencyVisible = !currencyVisible">
                  <span class="menuItem__label">{{ selectedCurrency }}</span>
                  <span class="icon-angle-down"></span>
                </a>
                @if (currencyVisible) {
                  <ng-container *ngTemplateOutlet="dropdown; context: {
                    list: clientObject.listOfCurrencies,
                    selected: selectedCurrency,
                    type: 'currency',
                  }"></ng-container> 
                }
              </div>
            </div>
            <div class="mobileMenu__trigger" (click)="mobileMenuVisible = !mobileMenuVisible">
              <span class="icon-cancel"></span>
            </div>
          </div>
          <div class="mobileMenu__scroller">
            <ul>
              @for (item of mainMenu; track $index) {
                <li>
                  <ng-container *ngTemplateOutlet="menuItem; context: { item: item} "></ng-container>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
  
  </div>
}